import React from "react";
import MwButton from "./MwButton";

export const NewButton = ({
  onClick,
  children,
  type = "",
  size,
  classNameCustom = "",
  disabled = false,
}) => {
  const baseStyles =
    "text-lg transition-all duration-300 outline-none border-none rounded-md md:min-w-[13%] py-4 text-white";
  const typeStyles =
    type === "main" || "newBtn"
      ? "bg-[#261759] hover:bg-[#463977] hover:text-white"
      : "bg-[red] hover:bg-[red] hover:text-white";
  const disabledStyles = "bg-gray-300 text-gray-500 cursor-not-allowed py-3";

  return (
    <MwButton
      onClick={onClick}
      disabled={disabled}
      type={type}
      classNameCustom={`${disabled ? disabledStyles : `${baseStyles} ${typeStyles}`} ${classNameCustom}`}
    >
      {children}
    </MwButton>
  );
};

export default NewButton;
